// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RatingTable{display:flex;flex-direction:column-reverse}.RatingTable__row{display:flex}.RatingTable__stars{color:#fdfcbf;margin-right:.5rem;width:5rem}.RatingTable__progressWrapper{align-items:center;display:flex;flex-grow:1;margin-right:.5rem;min-width:5rem}.RatingTable__progress{background-color:#bcbcc0;border:1px solid #dee2e6;border-radius:.5rem;height:.5rem}.RatingTable__value{font-size:.875rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
